import { OfficeType, OperatingSystemName } from "@core/constants";
import { AttentionListItemModel } from '@core/models/models/attention-list.model';

export class Utils {
  /**
  * Fake method IsNullOrEmpty of C#
  * @param value is anything
  * @returns is value null or empty(if valus is string)
  */
  public static isNullOrEmpty(value: any): boolean {
      if (value === undefined || value === null) return true;
      if (value?.toString()?.trim() === '') return true;
      return false;
  }

  /**
  * Get Operating System of user
  * @returns current device's Operating System name
  */
  public static getOS(): OperatingSystemName | null {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i;
    const windowsPlatforms = /(win32|win64|windows|wince)/i;
    let os: OperatingSystemName | null = null;

    if (macosPlatforms.test(userAgent)) {
      os = OperatingSystemName.Mac;
    } else if (windowsPlatforms.test(userAgent)) {
      os = OperatingSystemName.Windows;
    }

    return os;
  }
  
  public static isTsusho(value: number): boolean {
    return value === OfficeType.oldTsusho || value === OfficeType.newTsusho;
  }

  public static isNyusho(value: number): boolean {
    return value === OfficeType.oldNyusho || value === OfficeType.newNyusho;
  }

  /**
   * Determine whether an attention-list item is a supported handover record.
   */
  public static isAttentionListItem(item: unknown): boolean {
    if (!item || typeof item !== 'object') return false;

    const attentionItem = item as AttentionListItemModel;
    
    const noteKbn = attentionItem.notekbn ?? attentionItem.noteKbn;
    const docKbn = attentionItem.dockbn ?? attentionItem.docKbn;

    if(docKbn == null || noteKbn == null)
      return true;
    return (noteKbn === '0' || noteKbn === 0) && (docKbn === '0' || docKbn === 0);
  }
     /**
      * method isValidNumber
      * @param value is anything
      * @returns boolean
      */
     public static isValidNumber = (value: any) => typeof value === 'number' && value >= 0;

     /**
      * Check if the record is within a valid time period.
      * @param validSchedulePeriod - The latest valid schedule periods from session storage.
      * @param daiCd - The daiCd to look up the period.
      * @param recordTime - The record time to check against the period.
      * @returns True if the record is within the valid time frame, false otherwise.
      */
     public static isRecordInValidPeriod(validSchedulePeriod: any, daiCd: string, recordTime: string): boolean {
        if (!validSchedulePeriod || !daiCd) {
            return true;
        }

        const period = validSchedulePeriod[daiCd];

        if (!period || typeof period !== 'object' || !period.sDate || !period.eDate) {
            return false;
        }

        const recordDate = new Date(recordTime);
        const startDate = new Date(period.sDate);
        const endDate = new Date(period.eDate);

        return recordDate >= startDate && recordDate <= endDate;
     }
}